import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchBooks from "../Redux/Thunk/fetchBooks";
import { filterBySearchValue, filterByStatus } from "../utils/filterLogic";

import Book from "./Book";

const Books = () => {
 const filter = useSelector((state) => state.filter);
 const books = useSelector((state) => state.books);
 const dispatch = useDispatch();
 useEffect(() => {
  dispatch(() => fetchBooks(dispatch));
 }, []);

 return (
  <div>
   <div className="lws-bookContainer">
    {/* <!-- Card 1 --> */}
    {books
     .filter(filterByStatus(filter))
     .filter(filterBySearchValue(filter))
     .map((book) => (
      <Book key={book.id} book={book} />
     ))}
   </div>
  </div>
 );
};

export default Books;
